var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEtsy = function SvgEtsy(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 795.6 913.7",
    style: {
      enableBackground: "new 0 0 795.6 913.7"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.etsysvg{fill:#F27224;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "etsysvg",
    d: "M268.1,428.4V93.3c0-12.4,1.2-19.9,22.3-19.9h284.2c49.7,0,77,42.2,96.8,121.6l16.1,63.3H736 c8.7-180,16.1-258.2,16.1-258.2S630.5,13.8,558.5,13.8H194.9L0,7.6v52.1l65.8,12.4c45.9,8.7,57.1,18.6,60.8,60.8 c0,0,3.7,124.1,3.7,328.9c0,204.8-3.7,327.7-3.7,327.7c0,37.2-14.9,50.9-60.8,59.6L0,861.6v52.1l194.9-6.2h325.2 c73.2,0,243.3,6.2,243.3,6.2c3.7-44.7,28.6-247,32.3-269.3h-45.9l-48.4,110.5c-38.5,86.9-94.3,93.1-156.4,93.1H359.9 c-62.1,0-91.9-24.8-91.9-78.2v-283c0,0,135.3,0,182.4,3.7c34.8,2.5,55.8,12.4,67,60.8l14.9,64.5h53.3l-3.7-162.6l7.4-163.8h-53.4 l-17.4,72c-11.2,47.2-18.6,55.9-67,60.8c-54.6,6.2-183.7,5-183.7,5L268.1,428.4L268.1,428.4L268.1,428.4L268.1,428.4z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEtsy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "etsy.86c1b6f666b39d4941512ab46b865946.svg";